import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ComputedFrom } from '@certemy/common';
import { StepInstance } from 'services/professional/certificates/certificates.interface';

@Component({
  selector: 'cm-step-item-indicators',
  templateUrl: 'step-item-indicators.component.html',
  styleUrls: ['step-item-indicators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepItemIndicatorsComponent {
  @Input() step: StepInstance;

  @ComputedFrom('step')
  get paidInfo() {
    const { first_name, last_name, organization_name } = this.step.paid_by_info;
    return `${first_name} ${last_name} (Employer from ${organization_name}) has completed this step`;
  }
}
